export const getFullUrl = (path: string) => {
  const host = window.location.host;
  const isLocalHost = host.includes('localhost');
  return isLocalHost
    ? `https://${host}/#${path}`
    : `https://${host}/develop/#${path}`;
};
